import { useEffect, useState } from "react";

import { useParams, useSearchParams } from "react-router";

import { IdeaContext, createIdeaDraft } from "./hooks/useIdea";

export const IdeaProvider = ({
  children,
  ideaId: forcedIdeaId,
}: {
  children: React.ReactNode;
  ideaId?: string;
}) => {
  const [searchParams] = useSearchParams();
  const searchIdeaId = searchParams.get("idea");
  const params = useParams();
  const [ideaId, setIdeaId] = useState(
    forcedIdeaId || searchIdeaId || params.ideaId,
  );
  const [childId, setChildId] = useState<string | undefined | null>(undefined);
  const [draft] = useState(createIdeaDraft);
  useEffect(() => {
    setIdeaId(forcedIdeaId || searchIdeaId || params.ideaId);
    setChildId(null);
    draft.set({});
  }, [forcedIdeaId, searchIdeaId, params.ideaId, draft]);

  return (
    <IdeaContext.Provider
      value={{ ideaId, setIdeaId, childId, setChildId, draft }}
    >
      {children}
    </IdeaContext.Provider>
  );
};
